module.exports = __webpack_public_path__ + "img/access_denied.98839199.svg";